import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { alertActions } from "_store";
import { Typography, Button, Box } from "@mui/material";
import Popper from "@mui/material/Popper";
import Grid from "@material-ui/core/Grid";
import dayjs from "dayjs";
import FilterListIcon from "@mui/icons-material/FilterList";
import CustomStaticDateRangePicker3 from "_components/CustomStaticDateRangePicker3";

const MatrixComplianceFilter = ({ handleFilter, fromDate, toDate, isOpen, onClose, onOpen }) => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [isFormValid, setIsFormValid] = useState(false);

  const { handleSubmit, watch, setValue } = useForm({
    defaultValues: {
      SelectedDate: [dayjs(fromDate), dayjs(toDate)],
    },
  });

  const watchedValues = watch();

  useEffect(() => {
    if (fromDate && toDate) {
      setValue("SelectedDate", [dayjs(fromDate), dayjs(toDate)]);
    }
  }, [fromDate, toDate, setValue]);

  useEffect(() => {
    const hasValue = Object.values(watchedValues).some((value) => value !== "" && value !== null);
    setIsFormValid(hasValue);
  }, [watchedValues]);

  const canBeOpen = isOpen && Boolean(anchorEl);
  const id = canBeOpen ? "matrix-compliance-filter-popper" : undefined;

  const onSubmit = async (data) => {
    try {
      handleFilter(data);
      onClose();
    } catch (error) {
      dispatch(alertActions.error({ message: error?.message || error, header: "Fetch Failed" }));
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    if (isOpen) {
      onClose();
    } else {
      onOpen();
    }
  };

  const handleCancelClick = () => {
    onClose();
  };

  const handleClickAway = () => {
    onClose();
  };

  const handleDateRangeChange = (dateRange) => {
    setValue("SelectedDate", [dayjs(dateRange.startDate), dayjs(dateRange.endDate)]);
  };

  return (
    <>
      <Button className="Filter" type="button" variant="contained" color="primary" aria-describedby={id} onClick={handleClick}>
        <FilterListIcon />Filter
      </Button>
      <Popper id={id} open={canBeOpen} anchorEl={anchorEl} className="Filtercontainer">
        <Box sx={{ border: 1, p: 1, bgcolor: "background.paper" }} className="Filtercontainerinner Border">
          <form onSubmit={handleSubmit(onSubmit)} className="Registrationcontainer marketerFiltercontainer">
            <Typography component="div" className="userprofilelist">
              <Grid container direction="row" spacing={{ xs: 2, md: 3 }}>
                <Grid item xs={12} sm={6} md={6}>
                  <Typography variant="h2" className="userprofilelistcontent">Matrix Compliance</Typography>
                </Grid>
              </Grid>
            </Typography>

            <CustomStaticDateRangePicker3
              minimumDate={dayjs().subtract(12, "month")}
              maximumDate={dayjs().add(12, "month")}
              onDateRangeChange={handleDateRangeChange}
              label="Select Dates"
              startDate={fromDate}
              endDate={toDate}
              maxDays={31}
            />

            <Typography component="div" className="CreateMarketerbutton">
              <Button type="submit" variant="contained" className="submitbutton" color="primary" disabled={!isFormValid}>
                Search
              </Button>
              <Button variant="contained" color="red" className="cancelbutton" onClick={handleCancelClick}>
                Cancel
              </Button>
            </Typography>
          </form>
        </Box>
      </Popper>
    </>
  );
};

export default MatrixComplianceFilter;
